import React, { useCallback, useEffect, useState } from "react";

import { Input, Label, UncontrolledTooltip } from "reactstrap";

export default function CheckboxDisplay({
  attributes,
  rowId,
  colId,
  setValue,
}) {
  const [selected, setSelected] = useState(() => {
    if (!attributes.value) return [];
    if (Array.isArray(attributes.value)) return attributes.value;
    try {
      const parsed = JSON.parse(attributes.value);
      if (Array.isArray(parsed)) return parsed;
    } catch {}
    return [attributes.value];
  });

  const syncForm = useCallback(
    (newSelected) => {
      setValue((oldValue) => {
        const newValue = [...oldValue];
        newValue[rowId].cols[colId].attributes.value = newSelected;
        newValue[rowId].cols[colId].attributes.errorMessage =
          newSelected.length === 0 && attributes.required
            ? "Selecione pelo menos uma opção."
            : "";
        return newValue;
      });
    },
    [setValue, rowId, colId, attributes.required],
  );

  const handleChange = (value) => {
    const newSelected = selected.includes(value)
      ? selected.filter((item) => item !== value)
      : [...selected, value];
    setSelected(newSelected);
    syncForm(newSelected);
  };

  const setLabel = ({ value, id }) => {
    const html = value;
    const div = document.getElementsByClassName(
      `check-label-${rowId}-${colId}-${id}`,
    );

    for (const element of div) {
      element.innerHTML = html;
    }

    const askField = document.getElementsByClassName(
      `main-question-options-${rowId}-${colId}`,
    );

    for (const element of askField) {
      element.innerHTML = attributes.ask + (attributes.required ? '*' : '');
    }
  };

  useEffect(() => {
    syncForm(selected);
  }, []);

  return (
    <div id="therm-input-component">
      <div className="custom-input-container">
        <div className="displayed-config-container">
          <div className="displayed-label">
            {/* FIX_SSR_LABEL */}
            <span className={`main-question-options-${rowId}-${colId}`}>
              {attributes.ask}
            </span>
          </div>
        </div>
        {attributes.boxes.map((box, index) => (
          <div key={`id${index}`} style={{ display: "flex" }}>
            <Input
              className="input-mg-rgt"
              type="checkbox"
              id={`edit-input-check-show-${index}`}
              checked={selected.includes(box.label)}
              onChange={() => handleChange(box.label)}
            />
            {/* FIX_SSR_LABEL — children literal pra funcionar em SSR
                (editor via renderToString). useEffect continua reescrevendo
                via innerHTML no browser vivo — comportamento idempotente. */}
            <Label
              htmlFor={`edit-input-check-show-${index}`}
              className={`form-label check-label-${rowId}-${colId}-${index}`}
              style={{ display: "inline", marginRight: 2 }}
            >
              {box.label}
            </Label>
            {setLabel({ value: box.label, id: index })}
            {box.hasTip && (
              <div>
                <div
                  className="show-tips"
                  id={`tip-${rowId}-${colId}-${box.id}`}
                >
                  <span>?</span>
                </div>
                <UncontrolledTooltip
                  style={{ backgroundColor: "#6f42c1" }}
                  placement="right"
                  target={`tip-${rowId}-${colId}-${box.id}`}
                >
                  {box.tipText}
                </UncontrolledTooltip>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
